<template>
  <div class="layout">
    <div
      class="layoutLeft"
      :style="`width: ${leftWidth};transition: width ${time}ms;`"
      v-if="left"
    >
      <slot name="left"></slot>
    </div>
    <div style="width: 20px; position: relative">
      <div
        class="leftright"
        :class="leftWidth[0] == 0 ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
        @click="setWidth"
        v-if="show"
      ></div>
    </div>
    <div
      class="layoutRight"
      :style="`width: calc(100% - ${leftWidth});transition: width ${time}ms;`"
      v-if="right"
    >
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  // watch: {
  // 	"$store.state.path"(val) {
  // 		if (val) { //为true就修改宽
  // 			this.setWidth()
  // 		}
  // 	}
  // },
  data() {
    return {
      leftWidth: "200px", //0闭合  200px 展开
      // thatNum: 10,
    };
  },
  props: {
    width: {
      default: "200px",
      type: String,
    },
    time: {
      default: 400,
    },
    show: {
      default: true,
    },
    left: {
      default: true,
    },
    right: {
      default: true,
    },
  },
  methods: {
    setWidth() {
      this.leftWidth[0] != 0 ? (this.leftWidth = "0px") : (this.leftWidth = this.width);
      this.$addStorageEvent(2, "leftWidth", this.leftWidth[0]);
    },
    setWindow() {
      window.onresize = () => {
        if (document.body.clientWidth <= 1200 && this.leftWidth != "0px") {
          this.setWidth();
        }
      };
    },
  },
  mounted() {
    this.setWindow();
  },
};
</script>

<style scoped="scoped">
.layout {
  display: flex;
  width: 100%;
}

.layoutLeft {
  height: calc(100vh - 65px);
  border-right: 1px solid #e4eaed;
  white-space: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  background-color: #f5f6fa;
  cursor: pointer;
}

.layoutRight {
  position: relative;
  height: calc(100vh - 65px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.leftright {
  width: 15px;
  height: 66px;
  line-height: 66px;
  font-size: 0.8rem;
  text-align: center;
  font-size: 1rem;
  position: absolute;
  top: calc(50vh - 46px);
  left: -1px;
  color: #666;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  background-image: url(../assets/icon/layout.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@media screen and (max-width: 630px) {
  .leftright {
    display: none;
  }

  .layoutLeft {
    display: none;
  }
}
</style>
